import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { ErrorMessage, SalesPortalCheckoutProgressRetrieve, SalesPortalCheckoutProgressWrite } from 'types';
import { client } from 'utils/api-client';

interface IUseSalesPortalCheckoutProgressProps {
  gym: string;
  packageId: string;
  billingPlanId: string;
}

// Saves the buyer's non-payment checkout progress server-side (spec Item 11) so an
// abandoned checkout can be recovered from the email link. Upsert semantics: one row
// per buyer + gym + package + plan.
export default function useSalesPortalCheckoutProgress({
  gym,
  packageId,
  billingPlanId,
}: IUseSalesPortalCheckoutProgressProps): UseMutationResult<
  AxiosResponse<SalesPortalCheckoutProgressRetrieve>,
  AxiosError<ErrorMessage>,
  SalesPortalCheckoutProgressWrite
> {
  const saveProgress = (
    progress: SalesPortalCheckoutProgressWrite,
  ): Promise<AxiosResponse<SalesPortalCheckoutProgressRetrieve>> => {
    return client.put(
      `sales-portal/gyms/${gym}/packages/${packageId}/billing-plans/${billingPlanId}/checkout-progress/`,
      progress,
    );
  };

  return useMutation(saveProgress);
}
